import React from 'react';
import PropTypes from 'prop-types';

import SavedListsBenefitsPanel from '../SavedListsBenefitsPanel';
import styles from './savedListsEmptyState.scss';

const HEADING = 'Start Creating Lists';

const SavedListsEmptyState = ({ 'data-testid': dataTestId, showPreview }) => (
    <SavedListsBenefitsPanel
        data-testid={dataTestId}
        heading={HEADING}
        showPreview={showPreview}
        panelClassName={styles.panel}
        previewClassName={styles.preview}
    />
);

SavedListsEmptyState.propTypes = {
    'data-testid': PropTypes.string,
    showPreview: PropTypes.bool,
};

SavedListsEmptyState.defaultProps = {
    'data-testid': null,
    showPreview: true,
};

export default SavedListsEmptyState;
